import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import ProductsPage from "@/pages/ProductsPage";
import InquiryPage from "@/pages/InquiryPage";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFab from "@/components/WhatsAppFab";
import ScrollToTop from "@/components/ScrollToTop";

function App() {
    return (
        <div className="App font-sans text-navy">
            <BrowserRouter>
                <ScrollToTop />
                <Navbar />
                <main>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/products" element={<ProductsPage />} />
                        <Route path="/inquiry" element={<InquiryPage />} />
                        <Route path="*" element={<Home />} />
                    </Routes>
                </main>
                <Footer />
                <WhatsAppFab />
            </BrowserRouter>
            <Toaster position="top-right" richColors />
        </div>
    );
}

export default App;
